var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { Fragment, useEffect, useMemo, useRef, useState, } from "react";
import { TreeNavDivider } from "@animech/ui";
import * as Styled from "./custom-drawer.style";
import { drawerTransitionDelay } from "./custom-drawer.style";
import { ParameterList } from "./parameter-list";
import { useBlockingElementEffect } from "hooks/playcanvas/blocking-element-effect";
import { useCloseOnOutsidePointer } from "hooks/use-close-on-outside-pointer";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
/* The drawer lies over the canvas, and PlayCanvas listens on `window` for any
 * press within the canvas bounds, so while the scene is live, presses and
 * scrolls on the drawer are kept from reaching it. */
var stopScenePointer = function (event) { return event.stopPropagation(); };
var SceneFreeze = function () {
    useBlockingElementEffect();
    return null;
};
export var SidebarDrawerButton = function (props) {
    var button = props.button, id = props.id, sidebarWidth = props.sidebarWidth, keepSceneLive = props.keepSceneLive;
    var _a = __read(useState(false), 2), isVisible = _a[0], setIsVisible = _a[1];
    var dispatch = useAppDispatch();
    var activeDrawerItem = useAppSelector(selectors.selectActiveSidebarItemID);
    var sidebarContentContainerRef = useRef(null);
    var isDrawerActive = useMemo(function () { return activeDrawerItem !== undefined && activeDrawerItem === id; }, [activeDrawerItem, id]);
    // Close the drawer when the user clicks outside of its bounding box. A
    // text-selection drag that starts inside the drawer and is released outside
    // is not treated as an outside click, so the drawer stays open.
    useCloseOnOutsidePointer(isDrawerActive, [sidebarContentContainerRef], function () {
        return dispatch(actions.setActiveSidebarItemID());
    });
    // This useEffect will make sure that the modal has time to fade out entirely before it's disabled.
    useEffect(function () {
        if (isDrawerActive) {
            setIsVisible(true);
            return;
        }
        else {
            var timeout_1 = setTimeout(function () {
                setIsVisible(false);
            }, drawerTransitionDelay);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [isDrawerActive]);
    return (_jsxs(Styled.SidebarDrawerRoot, { isVisible: isDrawerActive, sidebarWidth: sidebarWidth, children: [_jsx(Styled.SidebarButtonContainer, { onClick: function () { return dispatch(actions.setActiveSidebarItemID(id)); }, children: button }), _jsx(Styled.SidebarDrawerContentContainer, { ref: sidebarContentContainerRef, onMouseDown: keepSceneLive ? stopScenePointer : undefined, onWheel: keepSceneLive ? stopScenePointer : undefined, children: isVisible && (_jsx(SidebarDrawerContent, __assign({}, props, { isOpen: isDrawerActive }))) })] }));
};
var SidebarDrawerContent = function (props) {
    var id = props.id, customRenderElement = props.customRenderElement, leadingRenderElement = props.leadingRenderElement, additionalRenderElement = props.additionalRenderElement, title = props.title, keepSceneLive = props.keepSceneLive;
    return (_jsxs(Styled.SidebarDrawerContentRoot, { children: [!keepSceneLive && _jsx(SceneFreeze, {}), title && (_jsxs(_Fragment, { children: [_jsx("h6", { children: title }), _jsx(TreeNavDivider, {})] })), customRenderElement ? (customRenderElement) : (_jsxs(Fragment, { children: [leadingRenderElement, _jsx(ParameterList, { groupIds: [id] }), additionalRenderElement] }, id))] }));
};
